import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { isDashboardAllowed, isPWA } from '@src/shared/utils';
import React from 'react';

interface componentProps {
  fixed: string | Boolean | undefined;
}
const HeaderWrapperSeparator = ({ fixed }: componentProps) => {
  const { isResolutionMobile, isAndroid, isIOS } = useDeviceDetect();
  const { restaurant } = useKeycloakUserState();

  const calculatedHeight = () => {
    if (
      (location.pathname === '/deliveries' &&
        !!isDashboardAllowed(restaurant?.country as string)) ||
      !isResolutionMobile
    ) {
      return '0px';
    }

    if (isPWA()) {
      const pwaAppScreensContainer = document.getElementById('pwaAppScreensContainer');
      const additionalHeight = pwaAppScreensContainer ? pwaAppScreensContainer.offsetHeight : 0;

      if (isAndroid) {
        return `${56 + additionalHeight}px`;
      }

      if (isIOS) {
        return `${86 + additionalHeight}px`;
      }
    }

    if (fixed) {
      return isPWA() ? '100px' : '56px';
    } else {
      return isPWA() ? '100px' : '0px';
    }
  };

  return (
    <div
      id="header-wrapper-separator"
      style={{
        height: calculatedHeight(),
        width: '1px',
        position: 'relative',
      }}
    ></div>
  );
};

export default HeaderWrapperSeparator;
